import { render, staticRenderFns } from "./addOrganization.vue?vue&type=template&id=0dd55ca0&scoped=true&"
import script from "./addOrganization.vue?vue&type=script&lang=js&"
export * from "./addOrganization.vue?vue&type=script&lang=js&"
import style0 from "./addOrganization.vue?vue&type=style&index=0&id=0dd55ca0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd55ca0",
  null
  
)

export default component.exports